class Dashboard {
    tab: WorkbookTab;

    appearance: DashboardAppearanceConfig;
    widgets: KnockoutObservableArray<DashboardWidget>;

    selectedWidget: KnockoutObservable<DashboardWidget> = ko.observable(null);
    maxHeight: number;
    maxWidth: number;

    constructor(data: any, tab: WorkbookTab) {
        this.tab = tab;

        this.appearance = new DashboardAppearanceConfig(data.appearance);
        this.widgets = ko.observableArray(createInstancesWithParameter(DashboardWidget, data.widgets as Array<any>, this));
        this.setupSettings();
    }

    setupSettings() {
        this.createSettingItem(this.appearance.backgroundColor);
        this.createSettingItem(this.appearance.widgetDefaultBackgroundColor);
    }

    getScrollLimit() {
        let maxWidth = 0;
        let maxHeight = 0;
        for (var widget of this.widgets()) {
            maxHeight = Math.max(maxHeight, widget.manualLayout.height() + widget.manualLayout.top());
            maxWidth = Math.max(maxWidth, widget.manualLayout.width() + widget.manualLayout.left());
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    }

    private dashboardElementHeight: number = 0;
    private $dashboardElement: HTMLElement;
    private currentZoom: number = 1;

    getDashboardElement() {
        return this.$dashboardElement;
    }

    setZoomOld($dashboardElement) {
        let $dashboardContainerElement = $(".dashboard-container", $dashboardElement);
        let $dashboardDesignerElement = $(".dashboard-designer", $dashboardElement);
        let $dashboardDesignerResizerElement = $(".dashboard-limit", $dashboardElement);
        let $dashboardLimitElement = $(".dashboard-limit", $dashboardElement);

        //set the original value because it can be a recalculate
        $dashboardDesignerResizerElement.css("transform", ``);
        $dashboardDesignerResizerElement.css("transform-origin", "");
        $dashboardLimitElement.css("width", ``);
        $dashboardLimitElement.css("height", ``);
        $dashboardDesignerElement.css("overflow", "auto");

        let designerWidthTotal = $dashboardDesignerElement[0].scrollWidth;
        let designerHeightTotal = $dashboardDesignerElement[0].scrollHeight;
        let designerWidth = $dashboardContainerElement.outerWidth();
        let designerHeight = $dashboardContainerElement.outerHeight();

        this.maxHeight = designerHeightTotal;
        this.maxWidth = designerWidthTotal;

        let scaleHeight = designerHeight / designerHeightTotal;
        let scaleWidth = designerWidth / designerWidthTotal;
        let scale = scaleWidth < scaleHeight ? scaleWidth : scaleHeight;
        if (scale > 1)
            scale = 1;

        $dashboardLimitElement.css("width", `${designerWidthTotal}px`);
        $dashboardLimitElement.css("height", `${designerHeightTotal}px`);

        $dashboardDesignerElement.css("overflow", "");

        $dashboardDesignerResizerElement.css("transform-origin", "left top");
        $dashboardDesignerResizerElement.css("transform", `scale(${scale})`);

        //console.log(`Set zoom: ${scale} for dashboard: ${this.tab.name()}`);

        this.configureResizableDraggable();
    }

    setZoom($dashboardElement: HTMLElement) {
        this.$dashboardElement = $dashboardElement;

        // let $dashboardContainerElement = $(".dashboard-container", $dashboardElement);
        // let $dashboardDesignerElement = $(".dashboard-designer", $dashboardElement);
        let $dashboardDesignerResizerElement = $(".dashboard-limit", $dashboardElement);
        // let $dashboardLimitElement = $(".dashboard-limit", $dashboardElement);

        // //set the original value because it can be a recalculate
        // $dashboardDesignerResizerElement.css("transform", ``);
        // $dashboardDesignerResizerElement.css("transform-origin", "");
        // $dashboardLimitElement.css("width", ``);
        // $dashboardLimitElement.css("height", ``);
        // $dashboardDesignerElement.css("overflow", "auto");

        this.dashboardElementHeight = $dashboardElement.clientHeight;
        
        // Calculate the scale based on the maximum width of the widgets
        const maxX = this.widgets().reduce((max, widget) => {
            const x = widget.manualLayout.left() + widget.manualLayout.width();
            return x > max ? x : max;
        }, 0);
        let $dashboardContainerElement = $(".dashboard-container", $dashboardElement);
        let designerWidth = $dashboardContainerElement.outerWidth();

        let scaleWidth = designerWidth / maxX;
        if (scaleWidth > 1)
            scaleWidth = 1;
        
        this.currentZoom = scaleWidth;
        this.maxWidth = designerWidth / scaleWidth;

        this.configureResizableDraggable();

        $dashboardDesignerResizerElement.css("transform-origin", "left top");
        $dashboardDesignerResizerElement.css("transform", `scale(${scaleWidth})`);
    }

    private scrollViewInstance: DevExpress.ui.dxScrollView;
    setScrollViewInstance(scrollViewInstance: DevExpress.ui.dxScrollView) {
        this.scrollViewInstance = scrollViewInstance;
    }

    scrollBy(x: number, y: number) {
        
        this.scrollViewInstance.scrollBy({ left: x, top: y });
    }

    scrollTop() {
        this.scrollViewInstance?.scrollTo(0);
    }

    getScrollContainer() {
        return this.scrollViewInstance?.content();
    }
    getScrollTop() {
        return this.scrollViewInstance?.scrollTop() || 0;
    }
    getScrollLeft() {
        return this.scrollViewInstance?.scrollLeft() || 0;
    }
    

    async configureResizableDraggable() {
        let editing = this.tab.workbookConfig.generalSettings.editing();

        for (let dashboardWidget of this.widgets()) {
            dashboardWidget.enableDisableResizableDraggable(editing);
        }
    }

    async updateMoveableRect() {
        if(!this.tab.workbookConfig.generalSettings.editing()) {
            return;
        }

        for (let dashboardWidget of this.widgets()) {
            dashboardWidget.updateMoveableRect();
        }
    }

    refresh() {
        for (let dashboardWidget of this.widgets()) {
            dashboardWidget.refresh();
        }
    }

    print() {
        window.open(`/Email/Html?scope=Dashboard&mappingId=${workbook.workbookConfig.mappingId}&workbookId=${workbook.workbookConfig.workbookId()}&tabId=${workbook.workbookConfig.activeTab().id()}&print=True&em=False`, "_blank").focus();
    }

    exportToPDF(isLandscape: boolean, templateId: number) {
        let href = `/Email/Pdf?scope=Dashboard&mappingId=${workbook.workbookConfig.mappingId}&workbookId=${workbook.workbookConfig.workbookId()}&tabId=${workbook.workbookConfig.activeTab().id()}`;
        if (isLandscape) {
            href += `&landscape=${isLandscape}`;
        }

        if (templateId && templateId > 0) {
            href += `&pdfTemplateId=${templateId}`;
        }

        window.open(href, "_blank").focus();
    }

    selectWidget(widget: DashboardWidget) {
        this.selectedWidget(widget);
        workbook.workbookConfig.isChangingTabOrWidget(true);
        if (widget) {
            workbook.workbookConfig.activeTabOrWidget(widget);
        }
        else {
            workbook.workbookConfig.activeTabOrWidget(workbook.workbookConfig.activeTab());
        }
        workbook.workbookConfig.isChangingTabOrWidget(false);

        setTimeout(function () {
            Ir.Components.Workbook.ToolBar.ReportToolBar.repaintToolbar();
            IntroService.refreshIntroHints();
        }, 150);
    }

    addWidget(widgetType: WidgetType, reportTemplateId: number = null) {
        let self = this;
        let submitObject = this.tab.getBaseSubmitObject() as any;
        submitObject.newWidgetType = widgetType;
        submitObject.reportTemplateId = reportTemplateId;

        let isDesignReport = reportTemplateId === NewReportStubTypeEnum.Chart || reportTemplateId === NewReportStubTypeEnum.Report || reportTemplateId === NewReportStubTypeEnum.Pivot;

        let o = {
            url: urlConfigs.dashboard + "AddWidget",
            data: submitObject,
            dataType: "json",
            async: true,
            showIndicator: false,

        } as RequestServerParams;
        o.successFunction = function (data, e) {
            let widget = new DashboardWidget(data.widget, self);
            self.widgets.push(widget);
            setTimeout(function () {
                self.selectWidget(widget);
                
                widget.manualLayout.left(1);
                widget.manualLayout.top(Math.round(self.getScrollTop()));

                //Configure all widgets because we need to include the new widget in elementGuidelines of the other widgets
                for (let dashboardWidget of self.widgets()) {
                    dashboardWidget.configureResizableDraggable();
                }

                if (isDesignReport) {
                    Ir.Components.ReportDesigner.ReportDesigner.showEditor(workbook.workbookConfig.activeTabOrWidget());
                }
            }, 300);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to create widget`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }
    copyFrom(widgetType: WidgetType, tabId: number, widgetId: number) {
        let self = this;
        let submitObject = this.tab.getBaseSubmitObject() as any;
        submitObject.newWidgetType = widgetType;
        submitObject.copyFromTabId = tabId;
        submitObject.copyFromWidgetId = widgetId;

        let o = {
            url: urlConfigs.dashboard + "CopyFrom",
            data: submitObject,
            dataType: "json",
            async: true,
            showIndicator: false,

        } as RequestServerParams;
        o.successFunction = function (data, e) {
            let widget = new DashboardWidget(data.widget, self);
            self.widgets.push(widget);
            setTimeout(function () {
                self.selectWidget(widget);
                widget.configureResizableDraggable();
            }, 300);
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to copy widget`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);
    }

    protected createSettingItem(property: KnockoutObservable<any>) {
        let self = this;
        property.subscribe(function (newValue) {
            self.saveSettings();
        });
    }
    private saveSettings(successFunction: () => void = null) {
        let submitObject = this.tab.getBaseSubmitObject();
        submitObject.appearance = ko.toJS(this.appearance);

        let o = {
            url: urlConfigs.dashboard + "SaveConfig",
            data: submitObject,
            dataType: "json",
            async: true
        } as RequestServerParams;
        o.successFunction = function () {
            if (successFunction) {
                successFunction();
            }
        };
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            errorItem.userMessage = `Failed to save dashboard settings`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };
        irGlobal.requestServer(o);
    }
}